var m = require('mithril');
var prop = require('mithril/stream')
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var modal = require('../layout/components/modal');
var heading = require('../components/heading');
var buttonElement = require('../components/button');
var Model = require('../libs/Model');
var reportBase = require('../../../../models/reports/report');
var Report = Object.assign({}, reportBase, Model);
Report.fields = Object.assign({}, reportBase.fields);
var customReport = require('./components/customReport');
var reportEquipmentTable = require('./components/reportEquipmentTable');
var jsonEquipmentExport = require('./components/jsonEquipmentExport');
var orComplianceReport = require('./components/orComplianceReport');
var requestStatusHandler = require('../layout/components/requestStatusHandler');
var RequestStatus = require('../layout/enums/RequestStatus');
var reportLocationField = require('./components/reportLocationField');
var reportEditorDownload = require('./reportEditorDownload');

var reports = {};
var reportTypeComponents = {
  custom: customReport,
  orCompliance: orComplianceReport,
  jsonEquipmentExport: jsonEquipmentExport
};

function loadReportTypes() {
  return loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/report/types',
    method: 'GET',
    background: true
  })
  .then(function (result) {
    if (result) {
      Report.applyRegistryPayload(result);
      m.redraw();
    }
    return result;
  })
  .catch(function () {
    return null;
  });
}

reports.oninit = function () {
  var ctrl = this;
  document.title = 'nimrod | Reports';
  header.vm.activeTab('Data');
  ctrl.record = prop();
  ctrl.requestStatus = prop(RequestStatus.PENDING);
  ctrl.requestStatusCode = prop();
  ctrl.nameDraft = prop('');
  ctrl.descriptionDraft = prop('');
  ctrl.detailsSaving = prop(false);
  ctrl.detailsError = prop('');
  ctrl.reportTypesPromise = loadReportTypes();

  var url = 'api/v1/report/' + m.route.param('id');

  ctrl.init = function () {
    ctrl.record(undefined);
    ctrl.requestStatus(RequestStatus.PENDING);
    ctrl.requestStatusCode();
    loaders.requestWithLoader({
      loader: 'main',
      url: url,
      method: "GET"
    })
    .then(function (response) {
      var report = response;
      if (!Array.isArray(report.out_Contains)) {
        report.out_Contains = [];
      }
      ctrl.record(report);
      ctrl.nameDraft(report.name || '');
      ctrl.descriptionDraft(report.description || '');
      ctrl.detailsError('');
      ctrl.requestStatus(RequestStatus.SUCCESS);
      m.redraw();
    })
    .catch(function (error) {
      ctrl.requestStatusCode(error && (error.status || error.code || (error.response && error.response.status)));
      ctrl.requestStatus(RequestStatus.ERROR);
      m.redraw();
    });
  };

  modal.on('closed', ctrl.init);
  ctrl.init();

  ctrl.saveDetails = function () {
    var record = ctrl.record();
    var nextName = String(ctrl.nameDraft() || '').trim();
    var nextDescription = String(ctrl.descriptionDraft() || '');
    if (nextName.length < 3 || nextName.length > 64) {
      ctrl.detailsError('Name must be between 3 and 64 characters.');
      m.redraw();
      return Promise.reject(new Error(ctrl.detailsError()));
    }
    if (!record || !record['@rid'] || (
      nextName === String(record.name || '') &&
      nextDescription === String(record.description || '')
    )) {
      return Promise.resolve(record);
    }

    ctrl.detailsSaving(true);
    ctrl.detailsError('');
    return loaders.requestWithLoader({
      loader: 'submit',
      url: '/api/v1/report/' + String(record['@rid']).replace(/^#/, ''),
      method: 'PUT',
      body: {
        name: nextName,
        description: nextDescription
      }
    })
    .then(function (updatedReport) {
      record.name = nextName;
      record.description = nextDescription;
      ctrl.nameDraft(nextName);
      return updatedReport || record;
    })
    .catch(function (error) {
      ctrl.detailsError(error && error.error
        ? error.error
        : (error && error.message ? error.message : 'Could not save the report details.'));
      return Promise.reject(error);
    })
    .finally(function () {
      ctrl.detailsSaving(false);
      m.redraw();
    });
  };
}

reports.onremove = function (vnode) {
  modal.off('closed', this.init);
};

reports.view = function (vnode) {
  var ctrl = this;

  if (ctrl.requestStatus() !== RequestStatus.SUCCESS || !ctrl.record()) {
    return m(requestStatusHandler, {
      requestStatus: ctrl.requestStatus,
      requestStatusCode: ctrl.requestStatusCode
    });
  }
  var label;
  var type = ctrl.record().type || 'Custom Export';
  var typeMeta = Report.getTypeMeta ? Report.getTypeMeta(type) : {};
  var typeLabel = typeMeta && typeMeta.displayName ? typeMeta.displayName : type;
  var downloadable = reportEditorDownload.hasDownloadableData(ctrl.record());
  var currentReportLabel = m('div.ml2.flex.items-center.flex-wrap', [
    m('span', ctrl.record().name),
    m('span.f5.fw6.ph2.pv1.ml2.br-pill.bg-dark-gray.light-blue.ba.b--mid-gray', typeLabel)
  ]);
  var hasFolder =
    ctrl.record().in_Contains &&
    Array.isArray(ctrl.record().in_Contains) &&
    ctrl.record().in_Contains[0] &&
    ctrl.record().in_Contains[0].out &&
    ctrl.record().in_Contains[0].out['@rid'] &&
    ctrl.record().in_Contains[0].out['@class'] == 'ReportFolder';

  if (hasFolder) {
    label = m('div.flex.pb2', [
      m(m.route.Link, {href: '/reports', class: 'mr2'}, 'Reports'),
      ' / ',
      m(m.route.Link, {href: `/reportfolder/${ctrl.record().in_Contains[0].out['@rid'].slice(1)}`, class: 'mh2'}, ctrl.record().in_Contains[0].out['name']),
      ' / ',
      currentReportLabel
    ])
  } else {
    label = m('div.flex.pb2', [
      m(m.route.Link, {href: '/reports', class: 'mr2'}, 'Reports'),
      ' / ',
      currentReportLabel
    ]);
  }
  

  return m('div', [
    m(heading, {label: label, class: 'f-subheadline mh3 mb3 pb1 display'}, [
      m(buttonElement, {
        label: 'Download',
        class: downloadable ? 'pointer blue b--mid-gray mb2' : 'silver b--mid-gray mb2',
        disabled: !downloadable,
        showFeedback: false,
        func: downloadable ? reportEditorDownload.open.bind(null, ctrl.record()) : undefined
      })
    ]),
    m('section.mh3.mt2.mb4', [
      m(reportLocationField, {record: ctrl.record(), class: ''})
    ]),
    renderDetails(ctrl),
    buildView(ctrl)
  ]);
}

function renderDetails(ctrl) {
  var record = ctrl.record();
  var nextName = String(ctrl.nameDraft() || '').trim();
  var nextDescription = String(ctrl.descriptionDraft() || '');
  var unchanged = nextName === String((record && record.name) || '')
    && nextDescription === String((record && record.description) || '');
  var disabled = ctrl.detailsSaving() || unchanged;
  return m('section.mh3.mb4', [
    m('label.db.f5.fw6.mb2', {for: 'report-name'}, 'Name'),
    m('input.form-control.pa2', {
      id: 'report-name',
      type: 'text',
      value: ctrl.nameDraft(),
      minlength: 3,
      maxlength: 64,
      placeholder: 'Report name',
      oninput: function (event) {
        ctrl.nameDraft(event.target.value);
        ctrl.detailsError('');
      },
      onkeydown: function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        ctrl.saveDetails().catch(function () {});
      }
    }),
    m('label.db.f5.fw6.mt3.mb2', {for: 'report-description'}, 'Description'),
    m('textarea.form-control.h4.pa2.lh-copy', {
      id: 'report-description',
      rows: 5,
      value: ctrl.descriptionDraft(),
      maxlength: 2000,
      placeholder: 'Add a description',
      oninput: function (event) {
        ctrl.descriptionDraft(event.target.value);
        ctrl.detailsError('');
      },
      onkeydown: function (event) {
        if (event.key !== 'Enter' || (!event.ctrlKey && !event.metaKey)) return;
        event.preventDefault();
        ctrl.saveDetails().catch(function () {});
      }
    }),
    m('div.flex.justify-end.mt2', [
      m(buttonElement, {
        label: 'Save',
        class: 'btn-good green dib',
        disabled: disabled,
        func: ctrl.saveDetails
      })
    ]),
    ctrl.detailsError() ? m('div.red.f6.mt2', ctrl.detailsError()) : null
  ]);
}

function buildView (ctrl) {
  var record = ctrl.record();
  var type = record && record.type ? record.type : 'Custom Export';
  var meta = Report.getTypeMeta ? Report.getTypeMeta(type) : {};
  var ui = meta && meta.ui ? meta.ui : {};
  var hasConfigPage = !(ui && ui.hasConfigPage === false);
  if (!hasConfigPage) {
    return m(customReport, ctrl);
  }
  var component = reportTypeComponents[ui.component];
  if (!component && ui && ui.equipmentTable && ui.equipmentTable.enabled) {
    component = reportEquipmentTable;
  }
  component = component || customReport;
  return m(component, ctrl);
};

module.exports = reports;
